import Button from "@mui/material/Button";
import { ComponentProps } from "../types";
import { CSSProperties, useContext, useMemo } from "react";
import { Icon, Tooltip } from "@mui/material";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import DashboardPageContext from "../DashboardPageContext";
import DashboardEnvContext from "../DashboardEnvContext";
import PagetActionsContext from "../PagetActionsContext";

function Component({ component, evalJsText, evaluteScript }: ComponentProps) {
	const dashboard = useContext(DashboardEnvContext);
	const pageContext = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const pageActions = useContext(PagetActionsContext);

	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		if (component.properties["width"]) style.width = component.properties["width"];
		return style;
	}, [component, exeMode]);

	const iconStyle = useMemo(() => {
		const style = {} as CSSProperties;
		if (component.properties["fontSize"]) style.fontSize = component.properties["fontSize"];
		return style;
	}, [component]);

	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		args["variant"] = (component.properties?.["variant"] || "text") as "text" | "elevation" | "outlined";
		args["color"] = (component.properties["color"] || "inherit") as "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
		if (component.properties["submitAction"]) {
			let actionPayload = undefined as unknown;
			if (component.properties["submitAction_Payload"]) {
				actionPayload = evaluteScript("const payload = " + component.properties["submitAction_Payload"] + "; payload");
			}
			if (dashboard) {
				args["onClick"] = () => {
					pageActions.executePageAction(component.properties["submitAction"], {
						row: undefined,
						actionPayload: actionPayload,
					});
				};
			}
		}
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		if (component.properties["disabled"]) args["disabled"] = evaluteScript(component.properties["disabled"]) as boolean;
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, pageContext.context, exeMode]);

	const componentStyles = useMemo(() => {
		try {
			if (component.styles) {
				const styles = typeof component.styles === "string" ? evaluteScript(component.styles) : component.styles;
				if (styles != undefined) return styles as CSSProperties;
			}
		} catch (error) {
			console.error(error);
		}
		return {} as CSSProperties;
	}, [component]);

	return (
		<Tooltip title={evalJsText(component.properties["tooltip"])}>
			<span>
				<Button key={component.id} {...args} sx={component.styles ? { ...style, ...componentStyles } : style}>
					<Icon style={iconStyle}>{evalJsText(component.properties["icon"])}</Icon>
				</Button>
			</span>
		</Tooltip>
	);
}

export default Component;
